import clsx from "clsx";
import { NewsFeedItem } from "@/shared/api/firehose/models";
import { HighlightInfo } from "@/utils/portfolioUtils";
import { FirehoseItem } from "./FirehoseItem";
import { ReactNode } from "react";

export function FirehoseHighlightItem(props: {
  item: NewsFeedItem;
  highlightInfo?: HighlightInfo;
  renderDetails?: (item: NewsFeedItem, highlightInfo?: HighlightInfo) => ReactNode;
}) {
  return (
    <div className={clsx("")}>
      <FirehoseItem
        item={props.item}
        titleStyle={{
          backgroundColor: props.highlightInfo?.color,
          color: props.highlightInfo && "black",
        }}
        highlightInfo={props.highlightInfo}
        renderDetails={props.renderDetails}
        endBadge={
          props.highlightInfo && (
            <span
              className="mx-1 text-xs"
              style={{ color: props.highlightInfo?.color }}
            >
              ({props.highlightInfo?.portfolioName})
            </span>
          )
        }
      />
    </div>
  );
}